import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { appInfo } from './app-info';
import { appRoutes, pageRoutes, redirectRoutes } from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { OpenPagesProvider, useOpenPages } from './contexts/open-pages';

const PageCache = () => {
  const { pages, activeKey } = useOpenPages();
  const location = useLocation();
  const routesWithoutOpenPage = new Set(['/overview', '/analytics', '/planning']);

  return (
    <div className='page-cache'>
      {routesWithoutOpenPage.has(location.pathname) && (
        <Routes location={location}>
          {pageRoutes.filter(route => routesWithoutOpenPage.has(route.path)).map(({ path, element: Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
        </Routes>
      )}
      {pages.map(page => (
        <div
          className={`open-page-panel${page.key === activeKey ? ' active' : ''}`}
          key={page.key}
          aria-hidden={page.key !== activeKey}
        >
          <Routes location={page.location}>
            {appRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </div>
      ))}
    </div>
  );
};

const RouteFallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const knownPath = pageRoutes.some(route => route.path === location.pathname)
      || redirectRoutes.some(route => route.path === location.pathname);
    if (!knownPath && location.pathname !== '/') {
      navigate('/overview', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export const Content = () => {
  return (
    <OpenPagesProvider>
      <SideNavBarLayout title={appInfo.title}>
        <RouteFallback />
        <Routes>
          {redirectRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route path='/' element={<Navigate to='/overview' replace />} />
          <Route path='*' element={null} />
        </Routes>
        <PageCache />
      </SideNavBarLayout>
    </OpenPagesProvider>
  );
};
